import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Html } from '#src/app/shared/components/html';

import { Label } from '../Label';

type Props = PropsWithChildren<{
	qaSelectorLabel: string;
	qaSelectorMessage: string;
	label: string;
	message: string;
}>;

export const RadioLabel: React.FC<Props> = ({ qaSelectorLabel, qaSelectorMessage, label, message, children }) => {
	return (
		<div className="cursor-pointer">
			<Label qaSelectorLabel={qaSelectorLabel} label={label} />
			<div className="flex flex-col gap-2 pt-2">
				<Html as="span" html={message} data-qa={qaSelectorMessage} className="text-sm leading-5 font-normal" />
				{children}
			</div>
		</div>
	);
};
